<template>
    <div>
        <div class="config-text-options" :class="configClasses">
            <div class="text">
                <slot name="input"/>
            </div>

            <div class="slot">
                <slot name="buttons"/>
            </div> 
        </div>
        <div v-if="isInputValid" class="warning">
            <slot name="msg"/>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'ui-util-input-button',

		props: {
			design: {
				type: String,
				default: '',
			},
			isInputValid: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			configClasses() {
				return {
					[this.design]: true,
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
